import style from "./StepNumber.module.css"

const StepNumber = (props) => {
  return <div className={style.StepNumber}>{props.data}</div>
}

export default StepNumber